import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {config} from '../../shared/config';
import {map} from 'rxjs/operators';
import {ControlledInputs} from '../models/controlled-inputs';
import {ControlledInputUpdate} from '../models/controlled-input-update';
import {ControlledInputUpdateResponse} from '../models/controlled-input-update-response';
import { BaseHttpService } from '../../core/services/base-http.service';
import { StorageService } from '../../core/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class ControlledInputService extends BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {
    super(_http, _storage);
  }

  public getControlledInputs(unitIds?: number[]): Observable<ControlledInputs[]> {
    const fields = ['*'];
    const unitIdsQuery = unitIds ? `&unitIds=${unitIds.join(',')}` : '';
    return this.get(config.generateApiUrl('controlledInputs', fields, null, '2.2') + unitIdsQuery).pipe(
      map(resp => {
        return resp['data']['items'] as ControlledInputs[];
      })
    );
  }

  public updateControlledInput(data: ControlledInputUpdate): Observable<ControlledInputUpdateResponse> {
    const fields = ['*'];

    return this._http.post(config.generateApiUrl(`controlledInputs`, fields, null, '2.2'), data).pipe(
      map((resp) => {
        return resp['data']['item'] as ControlledInputUpdateResponse;
      })
    );
  }


  public cancelControlledInputUpdate(data: Partial<ControlledInputUpdate>): Observable<ControlledInputUpdateResponse> {
    const fields = ['*'];

    return this._http.post(config.generateApiUrl(`controlledInputs/cancel`, fields, null, '2.2'), data).pipe(
      map((resp) => {
        return resp['data']['item'] as ControlledInputUpdateResponse;
      })
    );
  }
}
